import React, { useRef, useState, useEffect, forwardRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { API_URL_All } from '../../api';
import axios from "axios";
import { toast } from "react-toastify";
import * as general from '../../libs/general';
import axiosInstance from '../../axiosInstance';
import { CheckingTicket, LockingTicket, ClockIcon, EyeIcon } from '../../components/tickets/Tickets';
import OrderCommentModal from './OrderCommentModal';
import { useSelector } from 'react-redux';
import { resultMeta } from '../warehouse/scanResults';

const HistoryInfo = ({ data, handleSearch }) => {
  const canEdit = Boolean(data?.canEdit);
  const [show, setShow] = useState(true);
  const [model, setModel] = useState({});
  const [isOverdueMatched, setIsOverdueMatched] = useState(null);
  const [scanLogs, setScanLogs] = useState([]);
  const currentUser = useSelector((state) => state.user.user);
  const isStaff = currentUser?.isAdmin === true || currentUser?.isMember === true;

  useEffect(() => {
    fetchOneRecord(data);
  }, [data]);

  const handleModalClose = (e) => {
    document.querySelectorAll('.show .error-msg').forEach((item) => {
      if (item.parentNode) {
        item.parentNode.removeChild(item);
      }
    });
    document.activeElement.blur();
    setShow(false);
  };

  const handleSubmitForm = async(e) => {
    e.preventDefault();
    var errorTag = e.currentTarget.querySelector('.error-msg');
    if (errorTag) return;

    try {
      var requestApi = `/api/contacts/saveContactFee`;
      if (model.levelId) requestApi = `/api/levels/saveFee`;
      const response = await axiosInstance.post(requestApi, model);
      if (!response.data.success) {
        general.showFormError('#form_fee_editor .modal-body', response.data);
        console.log(response.data);
        return;
      }
      console.log(response);
      toast.success(response.data.message, { position: "top-right" });
      if (handleSearch) handleSearch();
      handleModalClose();
    } catch (error) {
      toast.error(error.response.data);
    }

  };

  const fetchOneRecord = async (params) => {
    document.querySelectorAll('form .error-msg').forEach((item) => { item.remove() });
    setIsOverdueMatched(null);
    
    const isNumber = Number.isFinite(params.id);
    if (!isNumber) {
      params.id = 0;
    }
    var requestApi = `/api/import-orders/findOrderLogs?id=${params.id}`;


    if (Number.isFinite(params.orderDetailId)) {
      requestApi = `/api/import-orders/findOrderLogs?referId=${params.orderDetailId}`;
    }

    try {
      const response = await axiosInstance.get(requestApi);
      if (response.data?.success === false) {
        toast.error(response.data?.message || 'Không có quyền xem lịch sử trạng thái.');
        setShow(false);
        return;
      }

      var obj = response.data;
      const orderId = obj?.data?.order?.id;
      if (Number.isFinite(orderId)) {
        const overdueResponse = await axiosInstance.get('/api/import-orders/checkOverdueCondition', {
          params: { orderId },
        });
        setIsOverdueMatched(Boolean(overdueResponse.data?.data));
      }

      setModel(obj);
      console.log(model);
      setShow(true);
      fetchScanLogs(orderId, params.orderDetailId);
    } catch (error) {
      console.error(error);
      toast.error(error.message);
    }
  };

  // Lịch sử quét Kho Vận — chỉ nhân viên; lỗi tải không ảnh hưởng lưu trình.
  const fetchScanLogs = async (orderId, orderDetailId) => {
    setScanLogs([]);
    if (!isStaff || !Number.isFinite(orderId)) return;
    try {
      const response = await axiosInstance.get('/api/warehouse/orderScanLogs', { params: { orderId } });
      const logs = response.data?.data || [];
      setScanLogs(Number.isFinite(orderDetailId)
        ? logs.filter((log) => log.orderDetailId == null || log.orderDetailId === orderDetailId)
        : logs);
    } catch {
      setScanLogs([]);
    }
  };

  const handleConfirmProcessTemporary = async () => {
    if (!canEdit) {
      toast.warning("Bạn không có quyền cập nhật.");
      return;
    }
    try {
      const orderId = model?.data?.order?.id;
      if (!Number.isFinite(orderId)) {
        toast.error('Không xác định được orderId', { position: "top-right" });
        return;
      }

      const response = await axiosInstance.post('/api/import-orders/confirmDelayedProcessing', null, {
        params: { orderId },
      });
      if (!response.data?.success) {
        toast.error(response.data?.message || 'Xác nhận thất bại', { position: "top-right" });
        return;
      }

      setIsOverdueMatched(false);
      toast.success(response.data.message, { position: "top-right" });
      if (handleSearch) handleSearch();
      handleModalClose();
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || error.message, { position: "top-right" });
    }
  }
  return (
    <Modal show={show} onHide={handleModalClose} size="lg">
      <div className="mb-3">

        <form id="form_fee_editor" className="form_validate normal-form" autoComplete="off" onSubmit={handleSubmitForm}>
          <div className="modal-content">
            <div className="modal-header position-relative flex-between">
              {model.data && model.data.order && (<span className="record_id">Code: {model.data.order.orderCode}</span>)}
              <h5 className="modal-title">Lịch sử trạng thái</h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleModalClose}
                aria-label="Đóng"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12 mb-3">
                  <div>
                    <label className="form-label">Đơn hàng: {model.data && model.data.order.name}</label>

                  </div>
                  {model.data && model.data.items.map((item, index) => (
                    <div className="history-item" data-progress-index={index} key={index}>
                      <div className="progress-name">{item.progressName}</div>
                      <div className="progress-time"><ClockIcon /> <span>{general.formatDateTime3(item.createdAt)}</span> </div>
                    </div>
                  ))}

                </div>
                {scanLogs.length > 0 && (
                  <div className="col-md-12 mb-3">
                    <label className="form-label fw-bold">Lịch sử quét Kho Vận</label>
                    <div className="table-responsive">
                      <table className="table table-sm mb-0">
                        <thead>
                          <tr>
                            <th>Thời gian</th>
                            <th>Thao tác</th>
                            <th>Mã vận đơn</th>
                            <th>Kết quả</th>
                            <th>Trạng thái</th>
                            <th>Người quét</th>
                          </tr>
                        </thead>
                        <tbody>
                          {scanLogs.map((log) => {
                            const meta = resultMeta(log.result);
                            return (
                              <tr key={log.id}>
                                <td className="text-nowrap">{general.formatDateTime3(log.createdAt)}</td>
                                <td>
                                  {log.scanType === 'OUT' ? `Xuất kho VN${log.sessionCustomerCode ? ` (${log.sessionCustomerCode})` : ''}` : 'Nhập kho VN'}
                                  {log.phase && <div className="small text-muted">{log.phase === 'CHECK' ? 'Quét kiểm tra' : 'Xác nhận'}</div>}
                                </td>
                                <td>{log.code}</td>
                                <td><span className={`badge bg-${meta.variant}`}>{meta.label}</span></td>
                                <td className="text-nowrap">
                                  {log.statusBeforeName || '-'}
                                  {log.statusAfterName && log.statusAfterId !== log.statusBeforeId && <> → {log.statusAfterName}</>}
                                </td>
                                <td>{log.userName || '-'}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>



            </div>
          </div>
        </form>
      </div>
      <div className='row normal-form'>
        <OrderCommentModal 
          orderId={data.id} 
          orderDetailId={data.orderDetailId}
          readOnly={!canEdit}
        />
      </div>
      <div className="modal-footer justify-content-between">
        {isOverdueMatched && isOverdueMatched === true ? (
          <button type="button" className="btn-sm btn btn-primary" disabled={!canEdit} onClick={handleConfirmProcessTemporary}>
            Xác nhận xử lý đơn chậm
          </button>
        ): <div></div>}
        <button type="button" className="btn-sm btn btn-primary" onClick={handleModalClose }>
          Đóng
        </button>
      </div>
    </Modal>
  );
};

export default HistoryInfo;
